import { memo, useRef } from "react";
import FilledButton from "../button/filled-button";
import { SearchInput } from "./search-input";

interface InlineSearchInputProps {
  label: string;
  onSubmit: (value: string) => void;
}

export const InlineSearchInput = memo(function InlineSearchInput({
  label,
  onSubmit,
}: InlineSearchInputProps) {
  const valueRef = useRef<string>("");
  return (
    <div className="w-full flex gap-4">
      <SearchInput
        placeholder="Search for a food"
        onValueChange={(nextValue) => (valueRef.current = nextValue)}
        onBlur={(trimmedValue) => (valueRef.current = trimmedValue)}
      />
      <FilledButton
        text={label}
        color="dark"
        className="rounded-md!"
        onClick={() => {
          const trimmedValue = valueRef.current.trim();
          if (trimmedValue === "") {
            return;
          }
          onSubmit(trimmedValue);
          valueRef.current = "";
        }}
      />
    </div>
  );
});
